import React from 'react';

import { View } from '@gogame/components';
import { rangePresets } from '@gogame/intl-ts';

import { usePerformance } from 'scenes/Gallery/GalleryPage/Creatives/data';
import Performance from 'scenes/Gallery/components/Performance';

const PerformanceTab = ({ creativeId }) => {
  const { data, isLoading, isRefetching } = usePerformance({
    id: creativeId,
    startDate: rangePresets.LAST_30_DAYS.value[0],
    endDate: rangePresets.LAST_30_DAYS.value[1],
  });

  return (
    <View loading={isLoading} fetching={isRefetching}>
      <Performance
        type={'CreativeFile'}
        id={creativeId}
        data={data}
        columns={4}
      />
    </View>
  );
};
export default PerformanceTab;
